import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignNowRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#0088CE",
		d: "M7.2 4.3h16.4l.6.2q1.4.4 2 1.7l.3 1v16.5l-.2.7q-.5 1.2-1.6 1.7l-.7.3-.3.1H7.1l-.8-.3q-1.3-.5-1.8-1.8l-.2-.8V7.2l.1-.4.2-.7q.6-1.1 2-1.6z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#FEFEFE",
		d: "M18 7.3q2-.1 3.7 1.1.6.6.7 1.5c0 1.3-1.1 2.1-2.4 2.2-.3 0-1.3-.2-1.4-.7 0-.2.5-.4.6-.5q.3 0 .4-.3.7-.6.2-1.2-.6-.6-1.6-.5-2 0-3.5 1.4a2 2 0 0 0-.6 1.5c0 1.3 1.5 2 2.5 2.5l1.3.7c1.4.8 2.7 1.8 2.7 3.5q0 1.6-1.1 2.7a9 9 0 0 1-5.8 2.3c-2 .1-5.2-.9-5.3-3.2 0-2 2-3.4 4-3.6 1.2 0 3.2.6 3.3 2.1q0 .8-.4 1.3a2 2 0 0 1-1.4.6c-.5 0-1.4-.1-1.4-.7 0-.4.5-.5.5-.8l-.2-.4q-.6-.4-1.1 0-1 .3-1 1.3c.1 1.5 2.1 1.7 3.3 1.6 1.8 0 4-1.5 3.9-3.5-.1-1.4-2.4-2.2-3.5-2.8q-.8-.3-1.6-1c-1.5-1.2-1.5-3.2-.2-4.6a8 8 0 0 1 5.3-2.5"
	})]
});
export default SvgSignNowRegularIcon;
